import {Elements} from "@stripe/react-stripe-js";
import {loadStripe, StripeElementsOptions} from "@stripe/stripe-js";
import {FlexAlign, FlexJustify, StackHorizontal} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from "react";

import {PayPalButtons, PayPalScriptProvider} from "@paypal/react-paypal-js";
import {useTranslation} from "@twigsby/frontend-framework";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

//const stripeInstance = loadStripe('pk_test_qblFNYngBkEdjEZ16jxxoWSM');

const PaymentDetails = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

/*    const [ stripeOptions, setStripeOptions] = useState<StripeElementsOptions>({
        appearance: {
            theme: "stripe"
        },
        mode: 'payment',
        currency: 'gbp',
        amount: 1,
    });*/

    useEffect(() => {
        updatePageMeta({
            title: t('settings.paymentDetails.title')
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t('settings.paymentDetails.title')}</h2>
            </StackHorizontal>

{/*            <Elements stripe={stripeInstance} options={stripeOptions}>
                <h4>Stripe</h4>
            </Elements>

            <h4>PayPal</h4>
            <PayPalScriptProvider options={{ "client-id": "test" }}>
                <PayPalButtons style={{ layout: "horizontal" }} />
            </PayPalScriptProvider>*/}
        </>
    )
}

export default PaymentDetails
